import { REACT_APP_TENANT_MANAGEMENT_URL } from "constants/constants";
import {
  getApiErrorMessage,
  parseFetchResponseBody,
} from "helpers/packageManagementApi";
import { tokenUtils } from "utils";

const extractTenantList = (responseBody) => {
  if (Array.isArray(responseBody)) {
    return responseBody;
  }

  if (Array.isArray(responseBody?.data)) {
    return responseBody.data;
  }

  if (Array.isArray(responseBody?.tenants)) {
    return responseBody.tenants;
  }

  if (Array.isArray(responseBody?.items)) {
    return responseBody.items;
  }

  return [];
};

export const fetchTenantsByVerticalId = async (verticalId) => {
  const normalizedVerticalId = String(verticalId ?? "").trim();

  if (!normalizedVerticalId) {
    return [];
  }

  const token = tokenUtils.getToken();
  if (!token) {
    throw new Error("You must be logged in to fetch tenants.");
  }

  if (!REACT_APP_TENANT_MANAGEMENT_URL) {
    throw new Error("Tenant management API URL is not configured.");
  }

  const baseUrl = REACT_APP_TENANT_MANAGEMENT_URL.replace(/\/$/, "");
  const url = `${baseUrl}/list-tenants-by-vertical-id/${encodeURIComponent(normalizedVerticalId)}`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  const responseBody = await parseFetchResponseBody(response);

  if (!response.ok) {
    throw new Error(
      getApiErrorMessage(responseBody, "Failed to fetch tenants.", response.status)
    );
  }

  return extractTenantList(responseBody);
};
